export default {
  LOAD_CYCLE_CASE_FORM_PAGE_START: 'LoadCycleCaseFormPageStart',
  LOAD_CYCLE_CASE_FORM_PAGE_END: 'LoadCycleCaseFormPageEnd',
  LOAD_CYCLE_CASE_AVAILABLE_CASES_START: 'LoadCycleCaseAvailableCasesStart',
  LOAD_CYCLE_CASE_AVAILABLE_CASES_END: 'LoadCycleCaseAvailableCasesEnd',
  LOAD_CYCLE_CASE_AVAILABLE_DIAGNOSES_START: 'LoadCycleCaseAvailableDiagnosesStart',
  LOAD_CYCLE_CASE_AVAILABLE_DIAGNOSES_END: 'LoadCycleCaseAvailableDianogsesEnd'
};